export default {
    PAUSE: 1,
    PAUSE_CHANGE: 2,
    UNPAUSE: 3
};
